import { Injectable, TemplateRef, inject } from '@angular/core';
import { NzNotificationRef, NzNotificationService } from 'ng-zorro-antd/notification';

import {
  UiNotificationConfig,
  UiNotificationTemplateData,
  UiNotificationType,
} from '@shared/components/ui-notification/ui-notification.types';

const DEFAULT_DURATION_MS = 4500;
const DEFAULT_PLACEMENT = 'top' as const;

@Injectable({ providedIn: 'root' })
export class UiNotificationService {
  private readonly nzNotification = inject(NzNotificationService);

  private templateRef?: TemplateRef<{ data: UiNotificationTemplateData }>;

  registerTemplate(template: TemplateRef<{ data: UiNotificationTemplateData }>): void {
    this.templateRef = template;
  }

  show(config: UiNotificationConfig): NzNotificationRef {
    if (!this.templateRef) {
      throw new Error('UiNotificationService: el template no está registrado.');
    }

    const notificationRef = this.nzNotification.template(this.templateRef, {
      nzData: {
        config,
        close: () => notificationRef.onClose.next(true),
      } satisfies UiNotificationTemplateData,
      nzDuration: config.duration ?? DEFAULT_DURATION_MS,
      nzPlacement: config.placement ?? DEFAULT_PLACEMENT,
      nzPauseOnHover: true,
      nzClass: 'ui-notification-notice',
    });

    return notificationRef;
  }

  success(title: string, message = '', duration?: number): NzNotificationRef {
    return this.show({ type: 'success', title, message, duration });
  }

  info(title: string, message = '', duration?: number): NzNotificationRef {
    return this.show({ type: 'info', title, message, duration });
  }

  error(title: string, message = '', duration?: number): NzNotificationRef {
    return this.show({ type: 'error', title, message, duration });
  }

  showByType(
    type: UiNotificationType,
    title: string,
    message = '',
    duration?: number,
  ): NzNotificationRef {
    return this.show({ type, title, message, duration });
  }
}
